import {useAuth} from '../../../contexts/UserContext';
import {useLocation, Navigate, Link, useNavigate} from 'react-router-dom';
import {useApp} from '../../../contexts/AppContext';
import {useEffect} from 'react';
import styled from 'styled-components';
import config from '../../../config';
import {
  SubInner,
  TabHeader,
  SectionTitle,
  InputLabel,
  RequiredLabel,
  FormInput,
} from '../../atoms/CommonParts';
import {PageTitle} from '.';
import LoginManager from '../../../libs/LoginManager';
import {NotLoginedHeaderArea} from '../../organisms/CommonParts';
const loginManager = LoginManager.getSharedInstance();
const Page = styled.div`
  padding-top: 53px;
  @media ${config.layout.wide} {
    padding-top: 45px;
  }
`;


const Thanks = styled.div`
  height: 134px;

  align-items: center;
  font-weight: bold;
  font-size: 26px;
  display: flex;
  text-align: center;
  @media ${config.layout.wide} {
    height: 144px;
  }

  span {
    width: 100%;
    display: block;
  }
`;

const Description = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 26px;
  margin-bottom: 50px;
  text-align: center;
  @media ${config.layout.wide} {
    margin-bottom: 60px;
  }
`;

const Description2 = styled.div`
  font-weight: bold;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 40px;
  text-align: center;
  @media ${config.layout.wide} {
    margin-bottom: 50px;
  }
`;

const VenueInfoBlock = styled.div`
  @media ${config.layout.wide} {
    display: flex;
    height: 184px;
    align-items: center;
  }
`;

const VenueInfoSection = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  height: 133px;
  align-items: center;
  justify-content: center;

  &:last-child {
    border-top: 1px solid #000000;
  }

  @media ${config.layout.wide} {
    width: 50%;
    height: 100px;
    &:last-child {
      border-top: none;
      border-left: 1px solid #000000;
    }
  }
`;

const VenueInfoKey = styled.div`
  font-size: 16px;
  line-height: 1;
  font-weight: bold;
`;

const VenueInfoValue = styled.div`
  font-size: 24px;
  line-height: 1;
  font-weight: bold;
  margin-top: 20px;
  user-select: auto;
`;

export default function RegistrationThanksPage() {
  const auth = useAuth();
  const location = useLocation();
  const app = useApp();
  let registerResult = (location.state && location.state.result) || null;

  useEffect(() => {
    app.hideHeader();
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 50);
    if (registerResult) {

      loginManager.setKeepLogin(true);
      loginManager.setAccessToken(
          registerResult.expires_in,
          registerResult.access_token,
      );
      try {
        let st = window.history.state;
        delete st.usr.result;
        window.history.replaceState(st, document.title);

      } catch (e) {
        console.error(e);
      }
    }
  }, []);

  if (auth.isLoggedIn()) {

    return <Navigate to={`/`} replace={true}/>;
  }

  if (!registerResult) {

    return <Navigate to={`/`} replace={true}/>;
  }

  console.log(registerResult);

  const onTopLink = (e) => {
    window.location.reload();
  };

  return (
      <Page>
        <NotLoginedHeaderArea/>

        <Thanks>
          <span>Thank you for registering!</span>
        </Thanks>
        <Description2>
          Save this ID and use it to log in to your venue account.
        </Description2>
        <Description>
          Your KUVO ID has been issued and sent to your e-mail address.
        </Description>
        <hr className="simple-border"/>
        <VenueInfoBlock>
          <VenueInfoSection>
            <VenueInfoKey>KUVO ID</VenueInfoKey>
            <VenueInfoValue>{registerResult.venue_code}</VenueInfoValue>
          </VenueInfoSection>
          <VenueInfoSection>
            <VenueInfoKey>Venue name</VenueInfoKey>
            <VenueInfoValue>{registerResult.name}</VenueInfoValue>
          </VenueInfoSection>
        </VenueInfoBlock>
        <hr className="simple-border"/>
        <button
            onClick={onTopLink}
            className="dark-button center-fixed"
            style={{
              marginTop: 40,
            }}
        >
          <span>Top</span>
        </button>
      </Page>
  );
}
